// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge.badge-pill[data-v-be3ac1f8]{height:2rem;display:inline-flex;align-items:center}.action-bar[data-v-be3ac1f8]{bottom:0;z-index:9}.sticky-container[data-v-be3ac1f8]{max-width:none}.custom-border[data-v-be3ac1f8]{border-top:2px solid #c7d121}", ""]);
// Exports
module.exports = exports;
